
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SelectOption extends Vue {
  @Prop() value!: string;
  @InjectReactive('selectedValue') selectedValue!: string;
}
